import type { PrimeVuePTOptions } from 'primevue/config';

export default {
  root: {
    class: 'max-w-72',
  },
  text: {
    class: 'text-sm',
  },
} satisfies PrimeVuePTOptions['directives']['tooltip'];
